import type { Invoice } from '@/types/portal';

export default function InvoiceTrail({ invoice }: { invoice: Invoice }) {
  return (
    <section className="rounded-lg border border-background-200 bg-background-50">
      <header className="border-b border-background-200 px-5 py-4">
        <h2 className="font-heading text-sm font-semibold text-foreground-950">
          Approval history
        </h2>
        <p className="mt-0.5 text-xs text-foreground-500">
          Every action on this invoice, most recent last
        </p>
      </header>

      <ol className="px-5 py-4">
        {invoice.trail.map((event, index) => {
          const last = index === invoice.trail.length - 1;
          return (
            <li key={event.id} className="relative flex gap-3 pb-5 last:pb-0">
              {!last ? (
                <span className="absolute left-[13px] top-7 h-full w-px bg-background-200" aria-hidden="true" />
              ) : null}
              <span
                className={`relative z-10 mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full border text-[13px] ${
                  last
                    ? 'border-primary-200 bg-primary-100 text-primary-700'
                    : 'border-background-200 bg-background-100 text-foreground-500'
                }`}
              >
                <i className="ri-record-circle-line" />
              </span>
              <div className="min-w-0 pt-0.5">
                <p className="text-sm font-medium text-foreground-900">{event.action}</p>
                <p className="text-xs text-foreground-500">
                  {event.actor} · {event.at}
                </p>
                {event.note ? (
                  <p className="mt-1.5 rounded-md border border-background-200 bg-background-100 px-3 py-2 text-xs italic text-foreground-600">
                    “{event.note}”
                  </p>
                ) : null}
              </div>
            </li>
          );
        })}
      </ol>
    </section>
  );
}